import Image from '@tiptap/extension-image'
import { ReactNodeViewRenderer } from '@tiptap/react'
import TiptapImage from './TiptapImage'

export const ExtensionImage = Image.extend({
  name: 'image',
  
  addAttributes() {
    return {
      ...this.parent?.(),
      src: {
        default: null,
      },
      alt: {
        default: null,
      },
      title: {
        default: null,
      },
      width: {
        default: '100%',
        parseHTML: element => element.style.width || '100%',
        renderHTML: attributes => ({
          style: `width: ${attributes.width}; max-width: 100%; height: auto;`,
        }),
      },
      height: {
        default: 'auto',
      },
    }
  },

  addNodeView() {
    return ReactNodeViewRenderer(TiptapImage)
  },
})